<div class="bn-dialog bn-extend-trial-all-users p-2 pb-0">
  <div
    class="bn-dialog__close"
    (click)="onClose()">
    <fa-icon
      aria-label="Close"
      icon="xmark"
      size="lg" />
  </div>
  <div class="bn-dialog__body">
    @if (isSuccess) {
      <ng-template [ngTemplateOutlet]="successScreen" />
    }
    @if (!isSuccess) {
      <div class="row">
        <div class="col-6 d-none d-md-block">
          <div class="bn-extend-trial-all-users__title ms-6">Have <strong>7 more days</strong>, on us.</div>
          <img
            class="bn-extend-trial-all-users__image"
            src="/assets/web-ui/images/bunny-holding-present.svg" />
        </div>
        <div class="col-12 col-md-6">
          <div class="bn-extend-trial-all-users__title d-block d-md-none text-center text-md-left ms-md-6">Have 7 more days, on us.</div>
          <div class="bn-extend-trial-all-users__content">
            <div class="bn-extend-trial-all-users__content__title">It`s good to have you back!</div>
            <p>
              Hey there! It`s been a while since we last saw you, and we`re so happy you hopped back in!
              <br />
              <br />
              Guess what? While you`ve been away, we`ve been busy making bunny.net better than ever. We`ve boosted performance, added new features, and even
              some new products.
              <br />
              <br />
              Why not bounce back and give it another go? Explore the latest features, and if you're ready for more, upgrade to unlock the full bunny potential!
              🚀
            </p>
            <hr class="mt-3 mb-4" />
            <div class="row">
              <div class="col-6">
                <fa-duotone-icon
                  class="bn-extend-trial-all-users__usage__item__icon"
                  size="lg"
                  [icon]="['fad', 'circle-dollar']" />
                <div class="bn-extend-trial-all-users__usage__item__value">
                  {{ usedTrialBalance ? (usedTrialBalance | currency: appConfig.currencySymbol : undefined : '1.2') : appConfig.currencySymbol + '0.00' }} /
                  {{ totalTrialBalance ? (totalTrialBalance | currency: appConfig.currencySymbol : undefined : '1.2') : appConfig.currencySymbol + '0.00' }}
                </div>
                <div>Trial usage</div>
              </div>
              <div class="col-12 my-3">
                <div class="bn-extend-trial-all-users__usage__progress-bar">
                  <div
                    class="bn-extend-trial-all-users__usage__progress-bar__cover"
                    [style.width]="100 - (totalTrialBalance ? (usedTrialBalance / totalTrialBalance) * 100 : 0) + '%'"></div>
                </div>
              </div>
            </div>
            <div class="bn-dialog__actions">
              <button
                bn-web-ui-button
                itemStyle="primary"
                size="lg"
                [fullWidth]="true"
                [loading]="isLoading"
                (click)="onExtendTrialClick()">
                Extend Your Free Trial
              </button>
            </div>
            <div class="text-center mt-2">
              Check out what's new on
              <a
                href="https://bunny.net/blog/"
                target="_blank"
                >our blog</a
              >.
            </div>
            @if (isError) {
              <bn-web-ui-alert
                alertType="danger"
                class="text-start mt-2"
                headerIcon="circle-exclamation"
                [showIcon]="true">
                Something went wrong, please try later!
              </bn-web-ui-alert>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>
<ng-template #successScreen>
  <div class="text-center">
    <div class="bn-extend-trial-all-users__title">Congratulations!</div>
    <div class="bn-extend-trial-all-users__success__text mb-6">Your Free Trial has been Extended.</div>
    <img src="/assets/web-ui/images/bunny-free-trial-extended.svg" />
  </div>
</ng-template>
